import { render, staticRenderFns } from "./Scanner.vue?vue&type=template&id=966087f4&scoped=true"
import script from "./Scanner.vue?vue&type=script&lang=js"
export * from "./Scanner.vue?vue&type=script&lang=js"
import style0 from "./Scanner.vue?vue&type=style&index=0&id=966087f4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "966087f4",
  null
  
)

export default component.exports